import { Invoice } from "../../buy/services/invoice.model";
import { PackageThumbnail, UserListeningPackagesResponse } from "../../common/services/package/package.model";
import NoAuthPackagesService from "./noauth-packages.service";
import NoAuthService from './noauth.service';

export default class UserInfoService {
    private msisdn: string;
    private packages: UserListeningPackagesResponse;
    private offerablePackages: PackageThumbnail[];
    private invoice: Invoice;

    private initiated = false;

    constructor(
        private $state,
        private noAuthService: NoAuthService,
        private noAuthPackagesService: NoAuthPackagesService
    ) { }


    public async initiateAllUserInfo(msisdn: string, warning: (key) => any) {
        if (!this.initiated) {
            this.msisdn = msisdn;

            var error = false;
            await this.noAuthPackagesService.checkUser(this.msisdn).then((userResult) => {
                if (userResult !== "") {
                    warning(userResult);
                    error = true;
                }
            });

            if (!error) {
                await this.noAuthPackagesService.getFilteredUserPackages(this.msisdn).then((packagesResult) => {
                    this.packages = packagesResult;
                });

                this.offerablePackages = [];
                this.packages.offerablePackages.forEach((offerable) =>
                    this.offerablePackages.push(this.noAuthPackagesService.convertListeningPackage(offerable))
                );

                await this.noAuthService.queryInvoiceInfo(this.msisdn).then(result => {
                    if (result) {
                        this.invoice = result;
                    }
                });
            }
            this.initiated = true;
        }
    }

    public checkOfferables(packetOfferId: string): string {
        for (var i = 0; i < this.packages.offerablePackages.length; i++) {
            var offerId = this.packages.offerablePackages[i].offerId;
            if (offerId && offerId === packetOfferId) {
                return "";
            }
        }

        for (var i = 0; i < this.packages.userListeningPackages.length; i++) {
            var lp = this.packages.userListeningPackages[i].listeningPackage;
            if (lp.offerId === packetOfferId) {
                return "hasPackage";
            }
            if (lp.premium) {
                return "default"
            }
        }
        return "purchased";
    }

    public async updatePackagesLanguage() {
        if (this.msisdn) {
            await this.noAuthPackagesService.getFilteredUserPackages(this.msisdn).then((packagesResult) => {
                this.packages = packagesResult;

                this.offerablePackages = [];
                this.packages.offerablePackages.forEach((offerable) =>
                    this.offerablePackages.push(this.noAuthPackagesService.convertListeningPackage(offerable))
                );
            });
        }
    }

    public getPackages() {
        return this.packages;
    }

    public getOfferablePackages() {
        return this.offerablePackages;
    }

    public getInvoice() {
        return this.invoice;
    }
}


// WEBPACK FOOTER //
// src/app/no-auth/services/user-info.service.ts